var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-tab", {
        ref: "nearmissTab",
        attrs: {
          type: "horizon",
          tabItems: _vm.tabItems,
          inlineLabel: true,
          height: _vm.tabHeight,
          dense: true,
        },
        on: {
          "update:tabItems": function ($event) {
            _vm.tabItems = $event
          },
          "update:tab-items": function ($event) {
            _vm.tabItems = $event
          },
          tabClick: _vm.tabClick,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tab) {
              return [
                _c(tab.component, {
                  tag: "component",
                  attrs: {
                    popupParam: _vm.popupParam,
                    isApprDisabled: true,
                    height: _vm.tabHeight,
                    count: _vm.count,
                  },
                  on: {
                    changeStatus: _vm.changeStatus,
                    closePopup: _vm.closePopup,
                    transInfo: _vm.transInfo,
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.tab,
          callback: function ($$v) {
            _vm.tab = $$v
          },
          expression: "tab",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }